/**
 * @generated SignedSource<<541b855060f48f14ca093520a8f71244>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Segment = "business" | "personal" | "sparkdigitalshop";
export type ProductDetailsNoAccountModalProviderAccountListQuery$variables = {};
export type ProductDetailsNoAccountModalProviderAccountListQuery$data = {
  readonly me: {
    readonly accountList: ReadonlyArray<{
      readonly accountId: string;
      readonly segment: Segment;
    }>;
  };
};
export type ProductDetailsNoAccountModalProviderAccountListQuery = {
  variables: ProductDetailsNoAccountModalProviderAccountListQuery$variables;
  response: ProductDetailsNoAccountModalProviderAccountListQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountList",
        "kind": "LinkedField",
        "name": "accountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "segment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductDetailsNoAccountModalProviderAccountListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProductDetailsNoAccountModalProviderAccountListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "610135283fbd6e09a82e769a838820f6",
    "id": null,
    "metadata": {},
    "name": "ProductDetailsNoAccountModalProviderAccountListQuery",
    "operationKind": "query",
    "text": "query ProductDetailsNoAccountModalProviderAccountListQuery {\n  me {\n    accountList {\n      accountId\n      segment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8252b7adca07ca8badc251330f659130";

export default node;
